import type { ReactNode } from "react";
import BottomTabBar from "@/components/BottomTabBar";

interface AppLayoutProps {
  children: ReactNode;
  userType?: "player" | "coach";
}

const AppLayout = ({ children, userType }: AppLayoutProps) => {
  return (
    <div className="relative flex h-[100dvh] w-full overflow-hidden bg-background">
      <div className="flex flex-1 flex-col min-h-0 min-w-0 overflow-hidden pb-14 md:pb-0">
        {children}
      </div>
      <BottomTabBar userType={userType} />
    </div>
  );
};

export default AppLayout;
